import { SLUG_MAX_LENGTH, toSlug } from '@explorentia/shared';

export {
  SLUG_MAX_LENGTH,
  SLUG_PATTERN,
  VILLAGE_SLUG_MAX_LENGTH,
  toSlug,
} from '@explorentia/shared';

/**
 * Zod preprocessor for slug fields: "Koilani Route" is saved as
 * `koilani-route` instead of failing validation, and a slug over `max` is
 * cut at a word boundary (villages pass `VILLAGE_SLUG_MAX_LENGTH`). The forms also rewrite the
 * field as the editor leaves it (see `slugBlur`), so what is saved is what
 * they saw; this catches Enter pressed inside the field.
 */
export const normSlug =
  (max: number = SLUG_MAX_LENGTH) =>
  (v: unknown) =>
    typeof v === 'string' ? toSlug(v, max) : v;

/** `register('slug', slugBlur(setValue))`: show the normalised slug on blur. */
export function slugBlur(
  setValue: (name: 'slug', value: string, opts: { shouldDirty: boolean }) => void,
  max: number = SLUG_MAX_LENGTH,
) {
  return {
    onBlur: (e: { target: { value: string } }) =>
      setValue('slug', toSlug(e.target.value, max), { shouldDirty: true }),
  };
}
